import React, { useEffect, useState } from 'react';
import { useTitle } from '../../Hooks';
import { Table, Header, Pagination } from 'react-frontier';
import { Business as BusinessClass } from '../../Classes';
import { Checkbox } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import API from '../../API';

const PAGE_SIZE = 10;

var Business = ()=>{
	var { setTitle } = useTitle();
	var [loadError, setLoadError] = useState<string>(null);
	var [businessList, setBusinessList] = useState<BusinessClass[]>(null);
	var [page, setPage] = useState<number>(0);
	var [showInactive, setShowInactive] = useState<boolean>(false);
	var [loading, setLoading] = useState<boolean>(false);

	useEffect(()=>{
		setTitle('Negocios');
		get();
	}, [showInactive]);

	var get = (get_page?: number)=>{
		var offset = (get_page > 0) ? Math.max(0, (get_page || page) * PAGE_SIZE) : 0;
		setLoading(true);
		API.businessList(offset, PAGE_SIZE, !showInactive).then(list=>{
			if(list.error) return setLoadError(list.message);
			return setBusinessList(list.data);
		}).catch(err=>{
			return setLoadError('Hubo un error al obtener los negocios. (GBL-1)'); 
		}).finally(()=>{
			setLoading(false);
		})
	}

	var onPageChange = (page: number)=>{
		setPage(page);
		get(page);
	}
	
	if(loadError){
		return <Header text='Error' subtext={loadError} />
	}

	if(!businessList){
		return <Header loading text='Cargando datos' />
	}
	
	return <div>
		<Table
			selectable
			title={showInactive ? 'Negocios Inactivos' : 'Negocios Activos'}
			footer={businessList.length >= PAGE_SIZE || page !== 0 ? (
				<Table.Row>
					<Table.Cell colSpan={4} style={{ textAlign: 'right' }}>
						<Pagination page={page} onPageChange={onPageChange} hasNext={businessList.length>=PAGE_SIZE} />
					</Table.Cell>
				</Table.Row>
			) : null }
			button={
				<Checkbox toggle style={{display:'flex', marginTop: 5 }} label='Mostrar Inactivos' checked={showInactive} onChange={() => setShowInactive(!showInactive)}/>
			}
			striped
			style={{  maxWidth: 600, margin: 'auto' }}
			headers={['ID', 'Nombre', 'Creador', 'Creación']}
			emptyText={businessList.length === 0 && 'No se encontraron registros'}
		>
			{loading ? (
				<Table.Cell row colSpan={5}>
					<Header size='small' loading text='Cargando datos' />
				</Table.Cell>
			) : businessList.map(b=>(
				<Table.Row compact as={Link} to={`/${b.business_id}`}>
					<Table.Cell>{b.business_id}</Table.Cell>
					<Table.Cell>{b.business_name}</Table.Cell>
					<Table.Cell>{b.user_creator_name}</Table.Cell>
					<Table.Cell>{moment.unix(b.date_created).format('DD/MMM/YY HH:mm')}</Table.Cell>
				</Table.Row>
			))}
		</Table>
	</div>
}

export default Business;